import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { N1DataUploadTable } from "./table";
import { N1DataUploadEdit } from "./edit";

export default function N1DataUpload() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Chargement de fichiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<N1DataUploadEdit />} />
      <Route index element={<N1DataUploadTable />} />
    </Routes>
  );
}
